import { render, staticRenderFns } from "./ServiceJob.vue?vue&type=template&id=40b4a1d7&scoped=true&"
import script from "./ServiceJob.vue?vue&type=script&lang=js&"
export * from "./ServiceJob.vue?vue&type=script&lang=js&"
import style0 from "./ServiceJob.vue?vue&type=style&index=0&id=40b4a1d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b4a1d7",
  null
  
)

export default component.exports